import generalCodeMessages from "@/utils/responseMessages/generalCodeMessages"
import adminCodeMessages from "@/utils/responseMessages/adminCodeMessages"
import attendanceCodeMessages from "@/utils/responseMessages/attendanceCodeMessages"
import groupCodeMessages from "@/utils/responseMessages/groupCodeMessages"
import importContactsCodeMessages from "@/utils/responseMessages/importContactsCodeMessages"
import customFieldCodeMessages from "@/utils/responseMessages/customFieldCodeMessages"
import wabaTemplateCodeMessages from "@/utils/responseMessages/wabaTemplateCodeMessages"
import metaAdsPluginCodeMessages from "@/utils/responseMessages/metaAdsPluginCodeMessages"
import upsellCheckoutCodeMessages from "@/utils/responseMessages/upsellCheckoutCodeMessages"
import forwardMessageCodeMessages from "@/utils/responseMessages/forwardMessageCodeMessages"

export default {
	...generalCodeMessages,
	...adminCodeMessages,
	...attendanceCodeMessages,
	...groupCodeMessages,
	...importContactsCodeMessages,
	...customFieldCodeMessages,
	...wabaTemplateCodeMessages,
	...metaAdsPluginCodeMessages,
	...upsellCheckoutCodeMessages,
	...forwardMessageCodeMessages
}
